export default "__VITE_ASSET__Bud2SEUz__"